import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isEmpty from 'lodash/isEmpty';
import LogRocketLibrary from 'logrocket';
import { getLogRocketConfig } from './config';
var LogRocket = /*#__PURE__*/function () {
  function LogRocket() {
    _classCallCheck(this, LogRocket);
  }
  _createClass(LogRocket, null, [{
    key: "getAppId",
    value: function getAppId() {
      var appIdFromEnvironment = process.env.LOGROCKET_APP_ID;
      return appIdFromEnvironment || 'abqepz/fisherman-websites';
    }
  }, {
    key: "init",
    value: function init(appId) {
      if (process.env.NODE_ENV === 'production') {
        var finalId = appId || LogRocket.getAppId();
        LogRocketLibrary.init(finalId, getLogRocketConfig());
      }
    }
  }, {
    key: "identify",
    value: function identify(userUuid) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? '' : _ref$name,
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? '' : _ref$email;
      var options = {};
      if (!_isEmpty(name)) {
        options = _objectSpread(_objectSpread({}, options), {
          name: name
        });
      }
      if (!_isEmpty(email)) {
        options = _objectSpread(_objectSpread({}, options), {
          email: email
        });
      }
      LogRocketLibrary.identify(userUuid, options);
    }
  }, {
    key: "captureError",
    value: function captureError(error) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$tags = _ref2.tags,
        tags = _ref2$tags === void 0 ? {} : _ref2$tags,
        _ref2$extra = _ref2.extra,
        extra = _ref2$extra === void 0 ? {} : _ref2$extra;
      LogRocketLibrary.captureException(error, {
        tags: tags,
        extra: extra // additional arbitrary data associated with the event
      });
    }
  }, {
    key: "captureErrorMessage",
    value: function captureErrorMessage(errorMessage) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$tags = _ref3.tags,
        tags = _ref3$tags === void 0 ? {} : _ref3$tags,
        _ref3$extra = _ref3.extra,
        extra = _ref3$extra === void 0 ? {} : _ref3$extra;
      LogRocketLibrary.captureMessage(errorMessage, {
        tags: tags,
        extra: extra // additional arbitrary data associated with the event
      });
    }
  }]);

  return LogRocket;
}();
export { LogRocket as default };